import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';

function validateEmail(mail) {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
}

function Mailer(props) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  // Estados para validación
  const [errors, setErrors] = useState({
    name: false,
    email: false,
    message: false,
  });

  function SendEmail(e) {
    e.preventDefault();

    // Validación manual
    const newErrors = {
      name: name.trim() === '',
      email: !validateEmail(email),
      message: message.trim() === '',
    };

    setErrors(newErrors);

    // Si hay algún error, no enviar
    if (newErrors.name || newErrors.email || newErrors.message) return;

    // Enviar con EmailJS
    emailjs.sendForm(
      'service_ciu1hmh',
      'template_j9ohkzj',
      e.target,
      'sVSo00CIm-Pv41BYQ'
    )
      .then(() => {})
      .catch(err => console.log(err));

    // Limpiar form
    setName('');
    setEmail('');
    setMessage('');
    setShow(true);
    setErrors({ name: false, email: false, message: false });
  }

  return (
    <div className="video-main-container game-design-container">
      <div className="row g-3 pt-4 justify-content-center">
        <div className="col-12 col-md-10 col-lg-8 col-xl-7">
          <form id="contactForm" className="form-wrapper" onSubmit={SendEmail} noValidate>
            <div className="form-floating mb-3">
              <input
                className={`form-control textos pt-5 ${errors.name ? 'is-invalid' : ''}`}
                name="name"
                id="name"
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
              />
              <label className="labeltext">{t('Name')}</label>
              {errors.name && <div className="invalid-feedback">{t('A name is required')}</div>}
            </div>

            <div className="form-floating mb-3">
              <input
                className={`form-control textos pt-5 ${errors.email ? 'is-invalid' : ''}`}
                id="email"
                name="user_email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <label>{t('Email')}</label>
              {errors.email && <div className="invalid-feedback">{t('Email is not valid')}</div>}
            </div>

            <div className="form-floating mb-3">
              <textarea
                name="message"
                rows="4"
                className={`form-control textos ${errors.message ? 'is-invalid' : ''}`}
                id="message"
                value={message}
                onChange={e => setMessage(e.target.value)}
              ></textarea>
              <label>{t('Message')}</label>
              {errors.message && <div className="invalid-feedback">{t('A message is required')}</div>}
            </div>

            <button className="btn btn-sm submit-button"  type="submit">
              {t('Send')}
            </button>
          </form>

          <Modal id="emailmodal" className="modal fade" show={show}>
            <Modal.Body>
              <div className="flex-container text-center">
                <h4 className="mt-5 mb-5 ml-2 mr-2">{t('Your email was sent.')}</h4>
                <button onClick={() => setShow(false)} className="submit-button btn btn-sm">
                  OK
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default Mailer;